const MEN_NAMES = {
  en: [
    { first: 'Mohamed', last: 'Hassan' },
    { first: 'Youssef', last: 'Ibrahim' },
    { first: 'Ahmed', last: 'Mahmoud' },
    { first: 'Karim', last: 'Mostafa' },
    { first: 'Omar', last: 'Khaled' },
    { first: 'Mahmoud', last: 'Farouk' },
    { first: 'Tarek', last: 'Gamal' },
    { first: 'Amr', last: 'Adel' },
    { first: 'Sherif', last: 'Hany' },
    { first: 'Khaled', last: 'Saeed' },
    { first: 'Nour', last: 'El-Din' },
    { first: 'Hassan', last: 'Ali' },
    { first: 'Ibrahim', last: 'Said' },
    { first: 'Mostafa', last: 'Kamal' },
    { first: 'Adel', last: 'Ashraf' },
    { first: 'Hany', last: 'Magdy' },
    { first: 'Saeed', last: 'Nabil' },
    { first: 'Ramy', last: 'Sherif' },
    { first: 'Bassem', last: 'Fawzy' },
    { first: 'Ehab', last: 'Lotfy' },
  ],
  ar: [
    { first: 'محمد', last: 'حسن' },
    { first: 'يوسف', last: 'إبراهيم' },
    { first: 'أحمد', last: 'محمود' },
    { first: 'كريم', last: 'مصطفى' },
    { first: 'عمر', last: 'خالد' },
    { first: 'محمود', last: 'فاروق' },
    { first: 'طارق', last: 'جمال' },
    { first: 'عمرو', last: 'عادل' },
    { first: 'شريف', last: 'هاني' },
    { first: 'خالد', last: 'سعيد' },
    { first: 'نور', last: 'الدين' },
    { first: 'حسن', last: 'علي' },
    { first: 'إبراهيم', last: 'سعيد' },
    { first: 'مصطفى', last: 'كمال' },
    { first: 'عادل', last: 'أشرف' },
    { first: 'هاني', last: 'مجدي' },
    { first: 'سعيد', last: 'نبيل' },
    { first: 'رامي', last: 'شريف' },
    { first: 'باسم', last: 'فوزي' },
    { first: 'إيهاب', last: 'لطفي' },
  ],
};

const WOMEN_NAMES = {
  en: [
    { first: 'Fatma', last: 'Ali' },
    { first: 'Salma', last: 'Abdelrahman' },
    { first: 'Mariam', last: 'Said' },
    { first: 'Hana', last: 'Nabil' },
    { first: 'Dina', last: 'Ashraf' },
    { first: 'Layla', last: 'Sherif' },
    { first: 'Rania', last: 'Emad' },
    { first: 'Nada', last: 'Magdy' },
    { first: 'Yasmin', last: 'Fawzy' },
    { first: 'Noura', last: 'Hassan' },
    { first: 'Aya', last: 'Mahmoud' },
    { first: 'Sara', last: 'Ibrahim' },
    { first: 'Heba', last: 'Kamal' },
    { first: 'Mona', last: 'Adel' },
    { first: 'Laila', last: 'Farouk' },
    { first: 'Reem', last: 'Saeed' },
    { first: 'Doaa', last: 'Gamal' },
    { first: 'Mai', last: 'Lotfy' },
    { first: 'Hoda', last: 'Nabil' },
    { first: 'Yasmine', last: 'Ashraf' },
  ],
  ar: [
    { first: 'فاطمة', last: 'علي' },
    { first: 'سلمى', last: 'عبد الرحمن' },
    { first: 'مريم', last: 'سعيد' },
    { first: 'هناء', last: 'نبيل' },
    { first: 'دينا', last: 'أشرف' },
    { first: 'ليلى', last: 'شريف' },
    { first: 'رانيا', last: 'عماد' },
    { first: 'ندى', last: 'مجدي' },
    { first: 'ياسمين', last: 'فوزي' },
    { first: 'نورا', last: 'حسن' },
    { first: 'آية', last: 'محمود' },
    { first: 'سارة', last: 'إبراهيم' },
    { first: 'هبة', last: 'كمال' },
    { first: 'منى', last: 'عادل' },
    { first: 'ليلى', last: 'فاروق' },
    { first: 'ريم', last: 'سعيد' },
    { first: 'دعاء', last: 'جمال' },
    { first: 'ماي', last: 'لطفي' },
    { first: 'هدى', last: 'نبيل' },
    { first: 'ياسمين', last: 'أشرف' },
  ],
};

const REVIEW_COMMENTS = {
  en: [
    'Great service and very professional staff!',
    'Clean place and the appointment was on time.',
    'Highly recommend, I will definitely come back.',
    'Excellent experience from start to finish.',
    'Friendly team and amazing results.',
    'Good value for money, very satisfied.',
    'The best shop in the area, hands down.',
    'Quick booking and smooth visit.',
    'Staff were welcoming and skilled.',
    'Perfect for a quick grooming session.',
    'Loved the atmosphere and attention to detail.',
    'Five stars — exceeded my expectations.',
  ],
  ar: [
    'خدمة ممتازة وطاقم محترف جداً!',
    'مكان نظيف والموعد كان في الوقت المحدد.',
    'أنصح بشدة، سأعود مرة أخرى بالتأكيد.',
    'تجربة رائعة من البداية للنهاية.',
    'فريق لطيف ونتائج مذهلة.',
    'سعر مناسب مقابل الخدمة، راضٍ جداً.',
    'أفضل محل في المنطقة بلا منازع.',
    'حجز سريع وزيارة سلسة.',
    'الموظفون كانوا مرحبين ومحترفين.',
    'مثالي لجلسة عناية سريعة.',
    'أحببت الأجواء والاهتمام بالتفاصيل.',
    'خمس نجوم — فاق توقعاتي.',
  ],
};

function shopSeed(shopId, shopName) {
  const key = String(shopId || shopName || 'default');
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = ((hash << 5) - hash) + key.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getReviewerNamePool(serviceCategory) {
  const category = String(serviceCategory || '').toLowerCase();
  if (category.includes('barber')) return 'men';
  if (category.includes('hair') && category.includes('nail')) return 'women';
  if (category.includes('pet')) return 'mixed';
  return 'mixed';
}

function pickReviewerName(poolType, lang, seed, index) {
  const men = MEN_NAMES[lang] || MEN_NAMES.en;
  const women = WOMEN_NAMES[lang] || WOMEN_NAMES.en;

  if (poolType === 'men') {
    return men[(seed + index * 17) % men.length];
  }
  if (poolType === 'women') {
    return women[(seed + index * 17) % women.length];
  }

  const useMen = (seed + index * 13) % 2 === 0;
  const pool = useMen ? men : women;
  return pool[(seed + index * 17) % pool.length];
}

export function getFakeReviewCount(shopId, shopName) {
  const seed = shopSeed(shopId, shopName);
  return (seed % 400) + 1;
}

export function getFakeRating(shopId, shopName) {
  const seed = shopSeed(shopId, shopName);
  return Math.round((3.8 + (seed % 13) * 0.1) * 10) / 10;
}

export function getDisplayRating(shop, shopId, shopName) {
  const rating = shop?.rating;
  if (typeof rating === 'number' && rating > 0) return rating;
  return getFakeRating(shopId, shopName);
}

export function getFakeReviewsForShop(
  shopId,
  shopName,
  lang = 'en',
  previewLimit = 10,
  serviceCategory = '',
) {
  const count = getFakeReviewCount(shopId, shopName);
  const seed = shopSeed(shopId, shopName);
  const poolType = getReviewerNamePool(serviceCategory);
  const comments = REVIEW_COMMENTS[lang] || REVIEW_COMMENTS.en;
  const limit = Math.min(previewLimit, count);

  const reviews = [];
  for (let i = 0; i < limit; i += 1) {
    const commentIdx = (seed + i * 31) % comments.length;
    const rating = 4 + ((seed + i * 7) % 2);
    const { first, last } = pickReviewerName(poolType, lang, seed, i);
    reviews.push({
      userName: `${first} ${last}`,
      rating,
      comment: comments[commentIdx],
    });
  }

  return { count, reviews };
}

export function mergeShopReviews(realReviews, fakeMeta) {
  const real = Array.isArray(realReviews) ? realReviews : [];
  const fake = Array.isArray(fakeMeta?.reviews) ? fakeMeta.reviews : [];
  const fakeCount = fakeMeta?.count || 0;
  return {
    reviews: [...real, ...fake],
    count: fakeCount + real.length,
  };
}

export function formatReviewCount(count, lang = 'en') {
  if (lang === 'ar') {
    return count === 1 ? 'تقييم واحد' : `${count} تقييم`;
  }
  return count === 1 ? '1 review' : `${count} reviews`;
}
